export default __webpack_public_path__ + "a67249894c5fbe6e249fe0657febdfb1.svg";